export default "__VITE_ASSET__BaGULltH__"